import moment from "moment";

export const convertDateStringToHuman = (dateString: string) => {
  const now = moment();
  const later = moment(dateString);
  const diff = later.diff(now);

  return moment.duration(diff).humanize();
};
